// extracted by mini-css-extract-plugin
module.exports = {"container":"_1I2dp","icon-spacer":"_3R9aC","iconSpacer":"_3R9aC","icon":"Y5Aux","button":"p-7m_"};